import { DASHBOARD_TYPE } from 'domain/entity/reportTemplate';

export enum DashboardAccessVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    GLOBAL = 'GLOBAL',
}

export enum DashboardPermittedAction {
    DELETE = 'DELETE',
    EDIT = 'EDIT',
    LINK = 'LINK',
    SHARE = 'SHARE',
    PIN = 'PIN',
    DUPLICATE = 'DUPLICATE',
}

export enum UserGroupLevel {
    EDIT = 'EDIT',
    VIEW = 'VIEW',
    NONE = 'NONE',
}

export class DashboardUserGroup {
    constructor(readonly id: string, readonly name: string, readonly level: UserGroupLevel) {
        if (id === undefined || name === undefined || level === undefined) {
            throw new ReferenceError('Undefined prop');
        }
    }
}

export type DashboardPermittedActions = {
    delete: boolean;
    edit: boolean;
    link: boolean;
    share: boolean;
    pin: boolean;
    duplicate: boolean;
};

export type DashboardAccess = {
    visibility: DashboardAccessVisibility;
    groups: DashboardUserGroup[];
};

export type DashboardOwner = {
    me: boolean;
};

class Dashboard {
    constructor(
        readonly id: string,
        readonly name: string,
        readonly pinned: boolean,
        readonly access: DashboardAccess,
        readonly owner: DashboardOwner,
        readonly permittedActions: DashboardPermittedActions,
        readonly starred: boolean,
        readonly type: DASHBOARD_TYPE,
        readonly description?: string
    ) {}

    public copyWithName(name: string): Dashboard {
        return new Dashboard(this.id, name, false, this.access, this.owner, this.permittedActions, this.starred, this.type);
    }

    public copyWith({
        name,
        access,
        owner,
        permittedActions,
    }: {
        name?: string;
        access?: DashboardAccess;
        owner?: DashboardOwner;
        permittedActions?: DashboardPermittedActions;
    }): Dashboard {
        return new Dashboard(
            this.id,
            name ?? this.name,
            false,
            access ?? this.access,
            owner ?? this.owner,
            permittedActions ?? this.permittedActions,
            this.starred,
            this.type
        );
    }
}

export default Dashboard;
